const moment = require("moment");
const {INVOICE_STATUS} = require("./InvoiceConstant");
const {fsMomentImport} = require("../utils/utils");
const InvoiceItem = require("./InvoiceItem")
const Address = require("../utils/Address");

class Invoice {

    constructor({
                    id = '',
                    additionalID = {},
                    status = INVOICE_STATUS.PENDING,
                    invoiceNumber = '',
                    dueDate = moment(),
                    address = new Address(),
                    title = '',
                    introduction = '',
                    paymentText = '',
                    closing = '',
                    item = [],

                    paymentID = [],
                    payment = [],
                    paymentMethodID = '',
                    paymentMethod = null,
                    customerID = '',
                    customer = null,
                    orderID = '',
                    order = null,

                    created = moment(),
                    createdBy = '',
                    updated = moment(),
                    updatedBy = '',

                } = {}) {

        this.id = id;
        this.additionalID = additionalID;
        this.status = INVOICE_STATUS[status] ? status : INVOICE_STATUS.PENDING;
        this.invoiceNumber = invoiceNumber;

        this.title = title;
        this.introduction = introduction;
        this.paymentText = paymentText;
        this.closing = closing;
        this.address = address;
        this.item = Array.isArray(item) ? item : [];

        this.paymentID = Array.isArray(paymentID) ? paymentID : [];
        this.payment = Array.isArray(payment) ? payment : [];
        this.paymentMethodID = paymentMethodID;
        this.paymentMethod = paymentMethod;
        this.customerID = customerID;
        this.customer = customer;
        this.orderID = orderID;
        this.order = order;

        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.created = null;
        this.updated = null;
        this.dueDate = null
        const field = ['created', 'updated', 'dueDate'];
        [created, updated, dueDate].forEach((date, index) => {
            date = fsMomentImport(date)
            this[field[index]] = date && date.isValid() ? date : null

        })
    }

    static get FS_COLLECTION_NAME() {
        return 'invoice'
    }

    static get INVOICE_STATUS() {
        return INVOICE_STATUS
    }

    get net(){
        return this.item.reduce((pre, cur) => pre + cur.net, 0)
    }

    get gross(){
        return this.item.reduce((pre, cur) => pre + cur.gross, 0)
    }

    get tax(){
        return this.gross - this.net
    }

    get taxAmounts(){
        const result = {};
        this.item.forEach((i) => {
            if(!result[i.vat]){
                result[i.vat] = {
                    vat: i.vat,
                    net: 0,
                    tax: 0,
                }
            }
            result[i.vat].net += i.net;
            result[i.vat].tax += (i.gross - i.net);
        })
        return Object.values(result).sort((a,b) => b.vat - a.vat)
    }

    validate(attribute) {

        if (attribute === undefined) {
            const attributes = Object.keys(this);
            try {
                attributes.map(attribute => {
                    if (!this._validate(attribute)) {
                        throw "validation error"
                    }
                });
            } catch (e) {
                return false
            }
            return true
        }

        return this._validate(attribute)
    }

    _validate(attribute) {

        try {
            switch (attribute) {
                case 'id':
                    return (typeof this[attribute] === 'string');
                default:
                    return false
            }
        } catch (e) {
            console.error('Validating Make with error:', e, attribute);
            return false
        }
    }

    toFirestore() {

        const item = {};

        try {
            this.item.forEach((i) => item[i.id] = i.toFirestore());

        } catch (e) {
            console.log('Could not convert invoice item')
        }

        return {
            id: this.id,
            additionalID: this.additionalID,
            status: this.status,
            invoiceNumber: this.invoiceNumber,
            dueDate: this.dueDate && (typeof this.dueDate.toDate === 'function') ? this.dueDate.toDate() : null,

            title: this.title,
            introduction: this.introduction,
            closing: this.closing,
            address: this.address.toFirestore ? this.address.toFirestore() : {},

            item,
            paymentID: this.paymentID,
            paymentMethodID: this.paymentMethodID,
            customerID: this.customerID,
            orderID: this.orderID,

            created: this.created && (typeof this.created.toDate === 'function') ? this.created.toDate() : null,
            createdBy: this.createdBy,
            updated: this.updated && (typeof this.updated.toDate === 'function') ? this.updated.toDate() : null,
            updatedBy: this.updatedBy,
        }
    }

    static parseFirestore(invoice, key, {customer = {}, payment = {}, paymentMethod = {}, order = {}}) {
        const _payment = [];

        invoice.paymentID.forEach((id) => {
            if (payment[id]) {
                _payment.push(payment[id])
            }
        })

        return new Invoice({
            ...invoice,
            id: key ? key : invoice.id,
            item: Object.values(InvoiceItem.fromFirestore(invoice.item)),
            payment,
            paymentMethod: paymentMethod[invoice.paymentMethodID] ? paymentMethod[invoice.paymentMethodID] : null,
            order: order[invoice.orderID] ? order[invoice.orderID] : null,
            customer: customer[invoice.customerID] ? customer[invoice.customerID] : null,
            address: Address.parseFirestore(invoice.address),
        })

    }

    static fromFirestore(fsSnap, {customer = {}, payment = {}, paymentMethod = {}}) {

        let data = {};
        if (fsSnap) {
            Object.keys(fsSnap).forEach((key) => {
                // the firestore object is not null
                if (fsSnap[key]) {
                    data[key] = Invoice.parseFirestore(...fsSnap[key], key, {customer, payment, paymentMethod})
                }
            });
        }

        return data
    }

    isSame(object) {

        return Object.is(
            JSON.stringify(object),
            JSON.stringify(this))
    }
}

module.exports = Invoice;